import * as React from 'react';
import { throttle } from 'throttle-debounce';
import { Tabs } from '@cian/ui-kit/prev/tabs';

import { modalFullscreen } from '../../constants/gallery';
import { getElementOffsetTop } from './getElementOffsetTop';
import { IGalleryItem } from '../../types/redux/gallery';
import { trackClick } from './tracking';

export interface IFullscreenGalleryTabsContainerProps {
  gallery: IGalleryItem[];
  offerId: number;
}

export const FullscreenGalleryTabsContainer: React.FC<IFullscreenGalleryTabsContainerProps> = ({
  gallery,
  offerId,
}) => {
  const [activeTab, setActiveTab] = React.useState(gallery[0].id);

  function scroll() {
    gallery.map(item => {
      const offsetTop = getElementOffsetTop(`#${item.id}`);

      if (offsetTop <= 200) {
        setActiveTab(item.id);
      }
    });
  }

  const handleScroll = throttle(400, scroll);

  React.useLayoutEffect(() => {
    const modalElement = document.querySelector(`#${modalFullscreen}`);
    /* istanbul ignore else */
    if (modalElement) {
      modalElement.addEventListener('scroll', handleScroll);
    }

    /* istanbul ignore next */
    return () => {
      if (modalElement) {
        modalElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const onClick = (id: string) => {
    const modalElement = document.querySelector(`#${modalFullscreen}`);
    const activeSection = document.querySelector<HTMLDivElement>(`#${id}`);
    if (modalElement && activeSection) {
      const offsetTop = activeSection.offsetTop;

      modalElement.scrollTo({
        behavior: 'smooth',
        left: 0,
        top: offsetTop,
      });

      trackClick({ label: id, offerId });
    }
  };

  return (
    <Tabs
      activeTab={activeTab}
      onChange={onClick}
      tabs={gallery.map(item => ({
        value: item.id,
        title: item.title,
      }))}
    />
  );
};
